import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import * as moment from 'moment';
import { AzureTokenModel } from '../../shared/models/azure-token.model';

@Injectable({
  providedIn: 'root'
})
export class AzureTokenService {

  constructor(private msalService: MsalService) { }

  public storeToken(tokenResponse: any) {
    try {
      if (!tokenResponse)
        return { error: 'Bad token response' }

      var convertedToken = new AzureTokenModel();
      convertedToken = JSON.parse(JSON.stringify(tokenResponse));

      localStorage.setItem('azure-token-for-pc', JSON.stringify(convertedToken));
    }
    catch (err) {
      return { error: err.message }
    }
  }

  public retrieveToken(): AzureTokenModel {
    //PRASE JSON BACK TO OUR OBJECT
    var val = localStorage.getItem('azure-token-for-pc');
    if (val) {
      var convertedToken = new AzureTokenModel();
      convertedToken = JSON.parse(val);
      return convertedToken;
    }
    else
      return null;
  }

  public isLoggedIn() {
    var val = localStorage.getItem('azure-token-for-pc');

    if (val) {
      var convertedToken = new AzureTokenModel();
      convertedToken = JSON.parse(val);

      return this.isTokenValid(convertedToken);
    }
    else {
      return false;
    }
  }


  public login() {
    let requestObj = {
      scopes: ["https://management.azure.com/user_impersonation"]
    };

    return new Promise((resolve, reject) => {
      this.msalService.acquireTokenPopup(requestObj).then((response) => {
        this.storeToken(response);
        resolve(true);
      }).catch((error) => {
        //MICROSOFT USER IS NOT LOGGED IN
        this.msalService.loginPopup(requestObj).then((loginResponse) => {
          //NOW THIS IS SUCESSFUL BUT WE DON'T HAVE TOKEN, LET'S GET THE TOKEN
          this.msalService.acquireTokenSilent(requestObj).then((sResponse) => {
            this.storeToken(sResponse); //TOKEN SHOULD BE STORED
            resolve(true);
          }).catch((error) => {
            reject(error);
          });
        }).catch((error) => {

          reject(error);
        })
      })
    });
  }

  public isTokenValid(token: AzureTokenModel): boolean {
    if (!token.accessToken) {
      return false;
    }


    //MICROSOFT'S DATE IS IN UTC, IT HAS TO BE CONVERTED TO LOCAL DATE TIME
    return moment().isBefore(moment(token.expiresOn).local());
  }
}
